module.exports = __webpack_public_path__ + "static/media/whiteboard2.9ac5e7a2.gif";